import { axiosJwt } from '@/shared/auth/axios-lib'
import { errorHandler } from '@/shared/errorHandler'

const api = `${process.env.VUE_APP_API_URL}${process.env.VUE_APP_API_PATH}`

export default {
    obterTodos(filtro) {
        return axiosJwt
            .get(`${api}/despesasgerais/requisitantes/despesas?status=${filtro.status != null ? filtro.status : ''}`
            ).then(response => {
                return response.data
            })
            .catch( error => {
                return errorHandler(error)
            })
    },

    obterFiltros() {
        return axiosJwt
            .get(`${api}/despesasgerais/requisitantes/despesas/filtros`)
            .then(response => {
                return response.data
            })
            .catch( error => {
                return errorHandler(error)
            })
    },

    obterPorId(despesaId) {
        return axiosJwt
            .get(`${api}/despesasgerais/requisitantes/despesas/${despesaId}`)
            .then(response => {
                return response.data
            })
            .catch( error => {
                return errorHandler(error)
            })
    },

    obterDespesasOpcoes() {
        return axiosJwt
            .get(`${api}/despesasgerais/requisitantes/despesas/opcoes`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterFornecedor(cpfcnpj) {
        return axiosJwt
            .get(`${api}/despesasgerais/requisitantes/despesas/fornecedor/${cpfcnpj}`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    inserirDespesa(despesaDto) {
        return axiosJwt
            .post(`${api}/despesasgerais/requisitantes/despesas/inserir`, despesaDto)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    atualizarDespesa(despesaDto) {
        return axiosJwt
            .put(`${api}/despesasgerais/requisitantes/despesas/atualizar`, despesaDto)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    comprometer(despesaId) {
        return axiosJwt
            .patch(`${api}/despesasgerais/requisitantes/despesas/${despesaId}/comprometer`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    excluirComprometimento(despesaId) {
        return axiosJwt
            .patch(`${api}/despesasgerais/requisitantes/despesas/${despesaId}/excluircomprometimento`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    solicitarAprovacao(despesaId) {
        return axiosJwt
            .patch(`${api}/despesasgerais/requisitantes/despesas/${despesaId}/solicitaraprovacao`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    devolver(despesaId) {
        return axiosJwt
            .patch(`${api}/despesasgerais/requisitantes/despesas/${despesaId}/devolver`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterErroComprometimento(despesaId) {
        return axiosJwt
            .get(`${api}/despesasgerais/requisitantes/despesas/${despesaId}/errocomprometimento`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },
    
    ajustarBoleto(despesaBoletoDto) {
        return axiosJwt
            .post(`${api}/despesasgerais/requisitantes/despesas/${despesaBoletoDto.despesaId}/ajustarboleto`, despesaBoletoDto)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterHistorico(despesaId) {
        return axiosJwt
            .get(`${api}/despesasgerais/requisitantes/despesas/${despesaId}/historico`)
            .then(response => {
                return response.data
            }).catch(error => {
                return errorHandler(error)
            })
    },
    
    obterTimeLine(despesaId) {
        return axiosJwt
            .get(`${api}/despesasgerais/requisitantes/despesas/${despesaId}/timeline`)
            .then(response => {
                return response.data
            }).catch(error => {
                return errorHandler(error)
            })
    },

    cancelar(despesaId, justificativaDto) {
        return axiosJwt
            .post(`${api}/despesasgerais/requisitantes/despesas/${despesaId}/cancelar`, justificativaDto)
            .then(response => {
                return response.data
            })
            .catch( error => {
                return errorHandler(error)
            })
    },

    pesquisarMovimentoCompra(movimentoId) {
        return axiosJwt
            .get(`${api}/despesasgerais/requisitantes/despesas/pesquisarmovimentocompra?movimentoId=${movimentoId}`)
            .then(response => {
                return response.data
            })
            .catch( error => {
                return errorHandler(error)
            })
    },

    inserirDespesaCompra(despesaDto) {
        return axiosJwt
            .post(`${api}/despesasgerais/requisitantes/despesas/inserirdespesacompra`, despesaDto)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    atualizarDespesaCompra(despesaDto) {
        return axiosJwt
            .post(`${api}/despesasgerais/requisitantes/despesas/atualizardespesacompra`, despesaDto)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },
}